import Link from 'next/link';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-secondary-950 flex flex-col items-center justify-center px-4">
      <div className="text-center max-w-md">
        {/* 404 illustration */}
        <div className="mb-8">
          <div className="text-9xl font-bold text-gray-200 dark:text-secondary-800">404</div>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 dark:text-secondary-100 mb-2">
          Page not found
        </h1>
        <p className="text-gray-500 dark:text-secondary-400 mb-8">
          Sorry, we couldn't find the page you're looking for. Perhaps you've mistyped the URL or the page has been moved.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link href="/dashboard">
            <Button variant="primary">
              <Home className="h-4 w-4 mr-2" />
              Go to Dashboard
            </Button>
          </Link>
          <button onClick={() => window.history.back()}>
            <Button variant="outline">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Back
            </Button>
          </button>
        </div>
      </div>
    </div>
  );
};

export { NotFoundPage };
